import { useFunnel } from "../context/FunnelContext";
import { useFunnelNavigation } from "./useFunnelNavigation";
import { trackStepComplete } from "../utils/analytics";

export function useStepData(stepId) {
  const { state, dispatch } = useFunnel();
  const { nextStep } = useFunnelNavigation();

  const updateStepData = (value) => {
    dispatch({
      type: "UPDATE_USER_DATA",
      field: stepId,
      value: value,
    });

    // Track step completion
    trackStepComplete(state.currentStep, value);
  };

  const handleNextStep = () => {
    nextStep();
  };

  return {
    data: state.userData[stepId],
    updateStepData,
    handleNextStep,
  };
}
